// eslint-disable-next-line import/order
import { PropsWithChildren } from "react";
import styles from "./style.module.css";
import { cn } from "@/core/helpers/cn";
import micGrillImg from "@/domains/estate/components/elevator/res/elevator-economy-mic-grill@2x.png";
import scratchesImg from "@/domains/estate/components/elevator/res/elevator-economy-scratches@2x.png";
import screwImg from "@/domains/estate/components/elevator/res/elevator-economy-screw@2x.png";

export function ElevatorEconomyFrame({
  children,
  size = "sm",
}: PropsWithChildren<{ size?: "sm" | "md" | "lg" }>) {
  return (
    <div className={cn(styles.container, styles[size])}>
      <div className={styles.scratches} style={{ backgroundImage: `url(${scratchesImg})` }} />

      <div className={styles.inner} />

      <div className={styles.header}>
        <img src={screwImg} alt="" className={styles.screw} />
        <img src={micGrillImg} alt="" className={styles.micGrill} />
        <img src={screwImg} alt="" className={styles.screw} />
      </div>

      <div className={styles.content}>{children}</div>

      <div className={styles.footer}>
        <img src={screwImg} alt="" className={styles.screw} />
        <img src={screwImg} alt="" className={styles.screw} />
      </div>
    </div>
  );
}
